<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="recordCode"
      resizable
      show-footer
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :footer-method="() => footerData"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displaySku="{ row }">
        <div v-if="row.amzSkuNo">
          <span class="mr-1">SKU:</span>
          <span>{{ row.amzSkuNo }}</span>
        </div>
        <div v-if="row.goodsName">{{ row.goodsName }}</div>
        <div v-if="row.goodsNameEn">{{ row.goodsNameEn }}</div>
      </template>
      <template v-slot:displaySpu="{ row }">
        <div v-if="row.amzSpuNo">
          <span class="mr-1">SPU:</span>
          <span>{{ row.amzSpuNo }}</span>
        </div>
        <div v-if="row.amzSpuName">{{ row.amzSpuName }}</div>
        <div v-if="row.amzSpuNameEn">{{ row.amzSpuNameEn }}</div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format, round } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    totalData: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = this.totalData[t.field]
          return val ? format(round(val)) : '0'
        })
      result[2] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
  },
}
</script>
